import React, { useRef } from "react";
import classes from "./HeroSection.module.scss";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import Slider from "react-slick";
import Container from "react-bootstrap/Container";
import CustomImage from "../../CustomImage";

const HeroSection = ({ heroSectionData }: { heroSectionData: any }) => {
  const bannerSettings = {
    dotsClass: classes.paginationDots,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
  };

  const sliderRef = useRef<Slider>(null);

  return (
    <div id="upcming-evnt-edtech" className={classes.heroSection}>
      <Container>
        <div className={classes.breadcrumbSection}>
          <Row className="text-center">
            <Col lg={12} md={12} xs={12} className={classes.centeredColumn}>
              <Breadcrumb>
                <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item href=""> Upcoming Events </Breadcrumb.Item>
              </Breadcrumb>
              <Slider
                {...bannerSettings}
                ref={sliderRef}
                className={classes.slider}
              >
                {heroSectionData?.bannersUrls?.length > 0 &&
                  heroSectionData?.banners?.map((banner: any, index: number) => {
                    return (
                      <a href={`${banner.linkUrl}`} key={index}>
                        <div key={banner.id} className={classes.bannerSlide}>
                          <CustomImage
                            src={banner.bannerUrl}
                            alt={banner.bannerAltTag}
                            width={1300}
                            height={600}
                            className={classes.objFit}
                          />
                        </div>
                      </a>
                    );
                  })}
              </Slider>
              <div className={classes.navArrows}>
                <div
                  className={classes.arrowButton}
                  onClick={() => sliderRef?.current?.slickPrev()}
                >
                  <CustomImage
                    src="/new-images/left-arrow.svg"
                    height={17}
                    width={10}
                    alt={"left-arrow"}
                  />
                </div>
                <div
                  className={classes.arrowButton}
                  onClick={() => sliderRef?.current?.slickNext()}
                >
                  <CustomImage
                    src="/new-images/right-arrow.svg"
                    height={17}
                    width={10}
                    alt={"right-arrow"}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;
